export default function createRouterHistoryPlugin(router) {
  // keep a tiny stack of "from" routes
  const stack = [];
  router.afterEach((to, from) => {
    if (from && from.fullPath) stack.push(from);
  });

  const api = {
    hasPrevious() {
      return stack.length > 0 || window.history.length > 1;
    },
    previous() {
      // Prefer our stack; fall back to native history state or root
      const prev = stack[stack.length - 1];
      if (prev) return prev;
      const path = router.options?.history?.state?.back || '/';
      return { path };
    },
    back() {
      if (this.hasPrevious()) router.back();
      else router.push({ name: 'WelcomePage' }); // or whatever the safe default is
    },
  };

  return {
    install(app) {
      app.config.globalProperties.$routerHistory = api;
      app.provide('routerHistory', api); // or, maybe, inject elsewhere
    },
  };
}
